// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"143":"ddf6d50199c7da5b4c0d","656":"7179737a287b8c143cb2","827":"fff88bcae52609852888","940":"755a987abd2bb5c49843"}[chunkId] + ".js";
};